module.exports = __webpack_public_path__ + "static/media/church.689675ed.svg";